export const determinarStatusEntrega = (checksEntrega = {}, options = {}) => {
    const { modoConferencia = 'Entregue' } = options;

    if (modoConferencia === 'Incompleto') {
        return 'Incompleto';
    }

    const valores = Object.values(checksEntrega);

    if (valores.length === 0) {
        return 'Incompleto';
    }

    const temFaltantes = valores.some((valor) => {
        if (typeof valor === 'boolean') {
            return !valor;
        }

        const quantidade = Number(valor);
        return Number.isFinite(quantidade) && quantidade > 0;
    });

    return temFaltantes ? 'Incompleto' : 'Entregue';
};
